<template>
  <ion-page>
    <master-layout @refreshPage="reRender" pageTitle="اطلاعات مأموریت">
        <ion-card-content class="mb-1">
          <Loading :is="!customerLoaded" v-if="!customerLoaded"></Loading>
          <div v-if="customerLoaded">
            <div v-if="customer">
              <ion-grid class="border-box">
                <ion-row>
                  <ion-col size="7">
                    <div>
                      <i class="fal fa-pen icon"></i><span>عنوان</span>
                    </div>
                    <div>
                      <i class="fal fa-user icon"></i><span>{{customer.fullname}}</span>

                    </div>
                    <div>
                      <i class="fal fa-mobile icon"></i><span>{{customer.phone}}</span>
                    </div>
                  </ion-col>
                  <ion-col size="5">
                    <a :href="'tel:'+customer.phone" class="btn btn-warning"><i class="far fa-phone"></i></a>&nbsp;
                    <a :href="'sms:'+customer.phone" class="btn btn-danger"><i class="far fa-envelope"></i></a>&nbsp;
                    <router-link class="btn btn-info" v-if="customer" :to="'/customer/Edit/'+customer._id"><i class="far fa-user"></i></router-link>
                  </ion-col>
                </ion-row>

                <hr>

                <ion-row>
                  <ion-col size="12">
                    <div>
                      <i class="fal fa-map icon"></i><span>{{customer.address_text}}</span>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-grid>

              <br>

              <ion-grid class="border-box">
                <ion-row>
                  <ion-col size="7">
                    <span>توضیحات: </span><span>{{customer.description}}</span>
                  </ion-col>
                </ion-row>
              </ion-grid>
              <div v-if="!mission_details.is_visit">
                <div v-if="mission_details.is_started">
                  <div>شروع شده در :
                  {{mission_details.start_date}}
                  </div>
                  <button ref="del_mission_time" @click="removeStartMissionItem()" class="btn btn-danger">حذف شروع ماموریت</button>
                </div>
                <div v-else>
                  <button ref="start_mission_btn" @click="startMissionItem()" class="btn btn-info mt-1">ثبت شروع ماموریت</button>
                </div>
              </div>
              <div v-if="message" :class="reject_reason_flag?'message-box danger':'message-box success'">{{message}}</div>

            </div>
            <div v-if="error" class="alert alert-danger">
              {{ error }}
            </div>

            <br>

            <div v-if="!mission_details.is_visit">

              <router-link :to="'/Order/Add/'+customer._id+'/'+mission_details._id" class="btn btn-block btn-success center">ثبت سفارش <i class="far fa-clipboard-check"></i></router-link>
              <button type="button" @click="show_reject_box = !show_reject_box" class="btn btn-primary btn-block mt-1">بدون سفارش&nbsp;<i class="far fa-times"></i></button>
            </div>
          </div>
        </ion-card-content>


        <ion-card-content v-if="show_reject_box">
<!--          <AjaxForm route="MissionItem/Reject">-->
            <input type="hidden" name="id" readonly :value="mission_details._id">
            <div v-for="(p,index) in no_order_reason" :key="index">
              <input :checked="no_reason_checked.indexOf(p._id) > -1" autocomplete="off" @change="changeNoReasons($event,p._id)" type="checkbox" :id="p._id" name="reject_id[]" :value="p._id">
              <label class="mr-1" :for="p._id">{{p.title}}</label><br>
            </div>
          <hr>
          <label>توضیحات عدم ثبت سفارش:</label>
          <textarea rows="2" class="form-control mb-2" v-model="reject_description"></textarea>
            <button ref="submitNoReasonBtn" @click="submitMissionItemRejectReason()" class="btn btn-info btn-block d-block" >ثبت دلایل رد سفارش</button>
<!--          </AjaxForm>-->
        </ion-card-content>

      <ion-card v-if="order_flag">
        <ion-card-content>
          <h2>اطلاعات ثبت سفارش</h2>
          <br>
          <div class="space_between">
            <span>شماره سفارش: </span><span>{{mission_details.order_number}}</span>
          </div>
          <div class="space_between">
            <span>تاریخ ثبت سفارش: </span><span>{{mission_details.op_date}}</span>
          </div>

          <br>
          <router-link class="btn btn-success btn-block" :to="'/Order/View/'+mission_details.order_id">اطلاعات سفارش</router-link>

        </ion-card-content>
      </ion-card>

      <ion-card v-if="reject_reason_flag">
        <ion-card-content>
          <div class="space_between">
            <span>تاریخ رد سفارش: </span><span>{{mission_details.op_date}}</span>
          </div>
          <hr>
          <h2>دلایل رد سفارش</h2>
          <br>
          <div v-for="(r,index) in reject_reasons" :key="index">
            <i class="fal fa-check icon"></i><span>{{ r.title }}</span>
          </div>
        </ion-card-content>
      </ion-card>


    </master-layout>
  </ion-page>
</template>

<script>
import { Geolocation} from '@capacitor/core';
import {alertController, IonCardContent, IonPage} from "@ionic/vue";
import {mapActions} from "vuex";
import AjaxForm from "@/components/AjaxForm";
import Loading from "../../components/Loading";
import {showSystemNoti} from "../../shared/helper";

export default {
  name: "customerInfo",
  components: {AjaxForm,IonPage,IonCardContent,Loading},
  data()
  {
    return {
      id: null,
      customerLoaded: false,
      customer: null,
      mission_details: null,
      error: null,
      show_reject_box: null,
      reject_description : '',
      no_order_reason: [],
      reject_reasons: [],
      order_flag: false,
      reject_reason_flag: false,
      is_visit_flag: false,
      message: null,
      no_reason_checked : []

    }
  },
  async mounted()
  {
    await this.init();
  },
  methods: {
    ...mapActions('mission',{
      getCustomerInfo: 'getCustomerInfo',
      submitStartMissionItem : 'submitStartMissionItem',
      deleteStartMissionItem : 'deleteStartMissionItem',
      getNoOrderReason: 'getNoOrderReason',
      submitRejectMissionItem : 'submitRejectMissionItem'
    }),
    async init()
    {
      this.customerLoaded = false;
      this.customer = null;
      this.mission_details = null;
      this.error = null;
      this.show_reject_box = null;
      this.order_flag = null;
      this.reject_reason_flag = null;
      this.is_visit_flag = null;
      this.message = null;
      this.reject_reasons = [];
      this.id = this.$route.params.id;
      const result = await this.getCustomerInfo(this.id);
      if (result)
      {
        if (result.ok)
        {
          this.customerLoaded = true;
          this.mission_details = result.mission_item;

          this.customer = this.mission_details.customer;
          if(this.mission_details.is_visit && this.mission_details.reject_reason)
          {
            this.reject_reason_flag = true;
            this.is_visit_flag = true;
            this.reject_reasons = this.mission_details.reject_reason;
            this.message = "سفارش توسط مشتری با دلایل زیر رد شد!";
          }
          if(this.mission_details.is_visit && this.mission_details.order_id)
          {
            this.order_flag = true;
            this.is_visit_flag = true;
            this.message = "سفارش با اطلاعات زیر ثبت گردید.";
          }
          const result2 = await this.getNoOrderReason();
          if(result2.ok)
            this.no_order_reason = result2.reasons;
        }
        else
        {
          this.customerLoaded = true;
          this.error = result.error
        }
      }
      else
      {
        this.customerLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور'
      }
    },
    reRender()
    {
      this.init();
    },
    async startMissionItem()
    {
      const self = this;
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'آیا اطمینان دارید!',
            message: 'وضعیت آیتم به شروع شده تغییر کند',
            buttons: [
              {
                text: 'لفو',
                role: 'cancel',
                cssClass: 'danger',
                handler: blah =>
                {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'تایید',
                handler: async () =>
                {
                  const s_btn = this.$refs['start_mission_btn'];
                  const btn_html = s_btn.innerHTML;
                  s_btn.setAttribute('disable','');
                  s_btn.innerHTML = 'در حال دریافت موقعیت <i class="far fa-spinner fa-pulse"></i>'
                  const l = await Geolocation.getCurrentPosition();
                  if (l)
                  {
                    const location = {lat: l.coords.latitude, lng: l.coords.longitude};
                    const result = await this.submitStartMissionItem(
                        {mission_item_id : this.mission_details._id,location});
                    s_btn.innerHTML = btn_html;
                    s_btn.removeAttribute('disable');
                    if (result.ok)
                    {
                      showSystemNoti('success','تاریخ شروع با موفقیت ثبت شد',function (){
                        self.init();
                      });
                    }
                    else
                      showSystemNoti('danger',result.error);
                  }
                  else
                    showSystemNoti('danger','موقعیت شما دریافت نشد.');
                },
              },
            ],
          });
      return alert.present();
    },
    async removeStartMissionItem()
    {
      const self = this;
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'آیا اطمینان دارید!',
            message: 'اطلاعات تاریخ شروع حذف میشود',
            buttons: [
              {
                text: 'لفو',
                role: 'cancel',
                cssClass: 'danger',
                handler: blah =>
                {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'تایید',
                handler: async () =>
                {
                  const btn = this.$refs['del_mission_time'];
                  const btn_html = btn.innerHTML;
                  btn.innerHTML = '<i class="far fa-spinner fa-pulse"></i>'
                    const result = await this.deleteStartMissionItem(this.mission_details._id);
                  btn.innerHTML = btn_html;
                    if (result.ok)
                    {
                      showSystemNoti('success','تاریخ شروع با موفقیت حذف شد.',function (){
                        self.init();
                      });
                    }
                    else
                      showSystemNoti('danger',result.error);
                },
              },
            ],
          });
      return alert.present();
    },
    changeNoReasons(e,r_id)
    {
      const index = this.no_reason_checked.indexOf(r_id);
      const is_checked = e.target.checked;
      if (is_checked)
      {
        if (index === -1)
          this.no_reason_checked.push(r_id);
          // this.no_order_reason.splice(index,1);
      }
      else if (index > -1)
        this.no_reason_checked.splice(index,1);
    },
    async submitMissionItemRejectReason()
    {
      const self = this;
      const no_reason_checked = this.no_reason_checked;
      if (no_reason_checked.length)
      {
        try
        {
          const options = {
            enableHighAccuracy: true,
          };
          const l = await Geolocation.getCurrentPosition(options);
          if (l)
          {
            const location = {lat: l.coords.latitude, lng: l.coords.longitude};
            const result = await this.submitRejectMissionItem({
              id: this.mission_details._id,
              description : this.reject_description,
              reject_id: this.no_reason_checked,location,
            });
            if (result)
            {
              if (result.ok)
              {
                showSystemNoti('success',result.message,function (){
                  self.init();
                });
              }
              else
                return showSystemNoti('danger',result.error);
            }
            else
              return showSystemNoti('danger', 'خطادر برقراری ارتباط با سرور..');
          }
          else
            return showSystemNoti('danger','خطا در دریافت موقعیت..');
        }
        catch (e)
        {
          return showSystemNoti('danger','خطا در دریافت موقعیت.');
        }
      }
      else
        showSystemNoti('danger','دلایل رد سفارش را انتخاب کنید.');
    }
  },
  watch : {
    "$route.path": {
      handler(newUrl,oldUrl)
      {
        if (newUrl.toLowerCase().indexOf('mission/customerinfo/') >= 0 && oldUrl.toLowerCase().indexOf('mission/customerinfo/') < 0)
        {
          this.init()
        }
      },
      deep:true
    },
  }
}
</script>

<style scoped>
.space_between
{
  display: flex;
  justify-content: space-between;
}
.border-box {
  border: 1px solid #ccc;
  border-radius: 5px;
}
.icon
{
  font-size: 18px;
  width: 30px;
  text-align: center;
}
.message-box {
  margin-top: 20px;
  border-radius: 5px;
  padding: 10px;
  text-align: center;
}
.message-box.danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

.mb-1
{
  margin-bottom: 5px;
}
.mr-1
{
  margin-right: 5px;
}
</style>